import { render, staticRenderFns } from "./SubmitForm12.vue?vue&type=template&id=f172cb9c&scoped=true"
import script from "./SubmitForm12.vue?vue&type=script&lang=ts"
export * from "./SubmitForm12.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f172cb9c",
  null
  
)

export default component.exports